import React, { useState, useEffect } from 'react';
import './WelcomeScreen.css'; // Đừng quên import file CSS

// Import hình ảnh từ assets
import lampIcon from '../assets/smartlamp.png';
import airIcon from '../assets/air.png';
import humiIcon from '../assets/humi.png';

const WelcomeScreen = ({ isVisible, onGetStarted }) => {
  const [userInfo, setUserInfo] = useState({
    name: 'User',
    email: ''
  });

  // Load user info from localStorage
  useEffect(() => {
    const loadUserInfo = () => {
      const user = localStorage.getItem('user');
      if (user) {
        try {
          const userData = JSON.parse(user);
          setUserInfo({
            name: userData.name || 'User',
            email: userData.email || ''
          });
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
    };

    if (isVisible) {
      loadUserInfo();
    }
  }, [isVisible]);

  // Get first letter of name for avatar
  const getInitial = () => {
    return userInfo.name ? userInfo.name.charAt(0).toUpperCase() : 'U';
  };

  // Get greeting based on time of day
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) {
      return 'Good morning';
    } else if (hour < 18) {
      return 'Good afternoon';
    } else {
      return 'Good evening';
    }
  };

  if (!isVisible) return null;

  return (
    <div className="welcome-container">
      {/* Hệ thống quỹ đạo (Orbit System) */}
      <div className="orbit-system">
        
        {/* Các vòng tròn trang trí (Rings) */}
        <div className="ring ring-1"></div>
        <div className="ring ring-2"></div>
        <div className="ring ring-3"></div>

        {/* Các vệ tinh (Icons) xoay quanh */}
        {/* Container xoay */}
        <div className="orbit-container">
            <div className="planet planet-lamp">
                <div className="planet-icon-box">
                    <img src={lampIcon} alt="Smart Lamp" />
                </div>
            </div>
            
            <div className="planet planet-air">
                <div className="planet-icon-box">
                    <img src={airIcon} alt="Air Purifier" />
                </div>
            </div>

            <div className="planet planet-humi">
                <div className="planet-icon-box">
                    <img src={humiIcon} alt="Humidifier" />
                </div>
            </div>
        </div>

        {/* Avatar người dùng ở chính giữa (Đứng yên) */}
        <div className="center-avatar">
          <div className="user-avatar-initial">
            {getInitial()}
          </div>
        </div>
      </div>

      {/* Phần Text và Button */}
      <div className="content-area">
        <h1 className="welcome-title">Hello, {userInfo.name}!</h1>
        <p className="welcome-subtitle">{getGreeting()}, welcome back.</p>
        
        <button className="welcome-btn" onClick={onGetStarted}>
          Get started
        </button>
      </div>
    </div>
  );
};

export default WelcomeScreen;